<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <!-- <el-select v-model="formDatas.adtrType" size="small" clearable placeholder="请选择类型"
                        style="width: 150px" @change="partserch">
                        <el-option label="普通会议室" :value="1"></el-option>
                        <el-option label="钉钉会议室" :value="2"></el-option>
                    </el-select> -->
                </el-row>

            </div>
            <div style="width: 10%; height: 40px">

            </div>
        </div>
        <div class="tablemain">
            <div style="height: 100%;overflow-x: auto;white-space: nowrap;" v-if="DingList.length > 0">
                <div style="width: 450px;display: inline-block;margin: 15px 20px;vertical-align: top;"
                    v-for="(item, index) in DingList" :key="index">
                    <el-card class="box-card">
                        <div slot="header" style="display: flex;align-items: center;justify-content: space-between;">
                            <div>
                                <el-image style="width: 100px; height: 100px;border-radius: 10px;"
                                    :src="item.roomPicture" :preview-src-list="[item.roomPicture]">
                                </el-image>
                            </div>
                            <div style="font-size: 18px;font-weight: 600;">
                                <div>{{ item.roomName }}</div>
                                <div style="font-size: 15px;margin-top: 15px;color: #909399;">
                                    <span style="margin-right: 30px;">容纳:{{ item.roomCapacity || '' }}</span>
                                    <span v-for="(data, id) in JSON.parse(item.roomLabels)" :key="id">{{ data.labelName
                                        || ''
                                        }}
                                        <span v-if="id != JSON.parse(item.roomLabels).length - 1">/</span>
                                    </span>
                                </div>
                                <div style="font-size: 15px;margin-top: 15px;color: #909399;" v-if="item.roomLocation">
                                    {{ JSON.parse(item.roomLocation).desc || '' }}</div>
                                <el-button style="padding: 10px 0" type="text"
                                    @click="handleDown(item, index)">下载二维码</el-button>
                            </div>
                            <div>

                                <el-button style="float: right; padding: 3px 0" type="text"
                                    v-if="item.adtrId != Did[index]" @click="DetailDingDing(item, index)">展开</el-button>
                                <el-button style="float: right; padding: 3px 0" type="text"
                                    v-if="item.adtrId == Did[index]" @click="CloseDingDing(item, index)">收起</el-button>
                            </div>
                        </div>
                        <div v-if="DingDetail[index] && item.adtrId == Did[index]"
                            style="max-height: 500px;overflow: auto;">
                            <el-card v-for="(row, rowId) in DingDetail[index].ajDingTalkRoomScheduleItemsList || []"
                                style="margin: 15px 5px;">
                                <div
                                    style="width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;flex-direction: row-reverse;">
                                    <p> {{ row.startDate }} - {{ row.endDate }}</p>
                                    <p>已被<span style="color: red;margin: 0 5px;">{{ row.userName }}</span>预定</p>
                                </div>
                            </el-card>
                        </div>

                    </el-card>
                </div>

            </div>


        </div>
    </div>
</template>

<script>
import { getAjDingTalkRoomList, getAjDingTalkRoomDetails } from "../../api/api";
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
export default {
    name: "",
    components: {},
    data() {
        return {
            Did: [],
            key: 'aptId',
            DingList: [],
            DingDetail: [],
            formDatas: {
                adtrType: 2,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjDingTalkRoomList(this.formDatas).then(res => {
            this.DingList = res.data;
            this.Did.length = this.DingDetail.length = res.data.length
        })
    },
    mounted() {

    },
    methods: {
        async handleDown(row) {
            // 创建二维码
            const writer = new BrowserQRCodeSvgWriter();
            const qrSvg = await writer.write('https://trainapp.aojuai.com/assets/meetingRoom.html?adtrId=' + row.adtrId, 200, 200);

            // 创建文字元素
            const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textElement.setAttribute('x', '100');
            textElement.setAttribute('y', '195');
            textElement.setAttribute('text-anchor', 'middle');
            textElement.setAttribute('font-family', 'Arial, sans-serif');
            textElement.setAttribute('font-size', '14');
            textElement.setAttribute('fill', '#000');
            textElement.textContent = '';

            // 创建组合SVG
            const combinedSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            combinedSvg.setAttribute('viewBox', '0 0 200 195');
            combinedSvg.setAttribute('width', '200');
            combinedSvg.setAttribute('height', '200');
            combinedSvg.appendChild(qrSvg);
            combinedSvg.appendChild(textElement);

            // 转换为PNG
            const svgBlob = new Blob([new XMLSerializer().serializeToString(combinedSvg)], { type: 'image/svg+xml' });
            const url = URL.createObjectURL(svgBlob);

            const img = new Image();
            img.src = url;

            await new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = () => {
                    URL.revokeObjectURL(url);
                    throw new Error('图片加载失败');
                };
            });

            const canvas = document.createElement('canvas');
            canvas.width = 200;
            canvas.height = 210;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            // 清理资源
            URL.revokeObjectURL(url);
            // 下载PNG
            let qrImageUrl = ''
            qrImageUrl = canvas.toDataURL('image/png');
            URL.revokeObjectURL(img);
            const link = document.createElement('a');
            link.href = qrImageUrl;
            link.download = row.roomName + '.png';
            link.click();
        },
        DetailDingDing(val, index) {
            this.openLoading()
            getAjDingTalkRoomDetails({ adtrId: val.adtrId }).then(res => {
                this.$set(this.DingDetail, index, res.data)
                this.$set(this.Did, index, val.adtrId)
                this.loadings.close()
                console.log(this.Did);
            })
        },
        CloseDingDing(val, index) {
            this.$set(this.DingDetail, index, '')
            this.$set(this.Did, index, '')
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        BoxOpen() {
            this.dialog = true;
        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aptId = row.aptId
                    console.log(jsonObj);
                    updateAjPurchaseGift(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjPurchaseGiftList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.DingList = this.Did.length = this.DingDetail = []
            getAjDingTalkRoomList(this.formDatas).then(res => {
                this.DingList = res.data;
                this.Did.length = this.DingDetail.length = res.data.length
            })
        },
        getList() {
            getAjPurchaseGiftList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>